// testimonialsData.js

const testimonials = [
  {
    name: "Vlada Reznikova",
    title: "Technical Lead at eg+ Worldwide",
    feedback: `
        Working with Maria is very easy, she is a great professional with a wide range of skills, very organized and detail-oriented, understands teamwork and loves what she does. She is a fast-learner and a problem-solver, a talented front-end developer who is always looking forward to gaining more skills and becoming more efficient. 
        `,
  },
  {
    name: "Jakiur Rahman",
    title: "Digital Project Manager at eg+ Worldwide",
    feedback: `
        Maria is an exceptional talent to have on any team. A true team player at her core, Maria always looks for efficiencies in her own work as well as the full team.
        With a keen eye for visual aesthetics and details, Maria's biggest strength lies in her understanding of the bigger picture and being able to deliver outstanding results whether that be to internal leadership teams or to clients.
        I look forward to seeing how much more Maria continues to grow in her career and I'm certain organizations will benefit tremendously from her insight, her positive can-do attitude, and her strong work ethic.
      `,
  },

  {
    name: "Jayleen Zhou",
    title: "Senior Front End Engineer at Amazon",
    feedback: `
        I worked with Maria in Paris Event Prestige as web developers. She worked on the portfolio site of the company. She is a fast-learning, a team-player, and a reliable liaison for tasks she is delegated to. She is passionate and pays attention into details in web development, and at the same time it is very pleasant to work with her.
      `,
  },
  {
    name: "Rick Freiberg",
    title: "CTO at Concinnity Marketing & Technology",
    feedback: `
    I've worked with Maria over the past year as part of a multi-agency effort to deliver consumer-facing digital solutions. I found her professionalism, knowledge, and attention to detail to be at a superb level. 
    This allowed for solution development to be fluid and absent of major issues compared to similar projects of this nature. I believe Maria to be an asset to her organization and easy to work with.
    `,
  },
  {
    name: "Yoni Engerran",
    title: "International Consultant at Expert New Generation Consultants",
    feedback: `
    Maria has been an active and efficient member that helped considerably to the development of my companies. She is a leader and a hard worker. Independent and perfectionist, she worked on great projects realizing my company's websites. 
    I would definitely recommend Maria.
    `,
  },
  {
    name: "Erich Otoba",
    title: "Senior Project Manager Entrée Health",
    feedback: `
        I have been working with Maria for a little less than a year and it has been been wonderful! I really appreciate that Maria has always been on time with delivering my projects. Anytime I have any questions or requests she is excellent with getting back to me in a timely manner. I couldn’t recommend Maria enough!
      `,
  },
  {
    name: "Gabriella O’Donohue",
    title: "Art Director FCB Health",
    feedback: `
        Fantastic and professional worker. Maria exceeds at her craft and goes above and beyond to help everyone out. It was a pleasure working with her! 
        `,
  },
];

export default testimonials;
